import { useState, useEffect, useRef } from "react";
import { Grid, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import GeneralNoPaginationTable from '../components/Table/GeneralNoPaginationTable';
import MainCard from '../components/MainCard';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import MixedChart from '../components/Chart/MixedChart';



const summaries_columns = [
  { id: 'data_month', label: 'Month', align: 'center'},
  { id: 'total', label: 'Total', align: 'center'},
  { id: 'automated', label: 'Automated', align: 'center'},
  { id: 'percentage', label: '%', align: 'center'},
];


const TestRailSYSAutomatedInfoPage = () => {
    const navigate = useNavigate();
    const [summariesData, setSummariesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [percentage, setPercentage] = useState([]);
    const [totalList, setTotalList] = useState([]);
    const [automatedList, setAutomatedList] = useState([]);
    const [selected, setSelected] = useState('10539');
    const initialFetchRef = useRef(true);
    const [selectedTitle, setSelectedTitle] = useState('Affernet');
    const handleSelection = (event, newSelection) => {
      setSelected(newSelection);
      getTestrailAutomatedCases(newSelection);
      if (newSelection === '10539') {
        setSelectedTitle('Affernet');
      }else if (newSelection === '10538') {
        setSelectedTitle('OTAService');
      }else if (newSelection === '10540') {
        setSelectedTitle('Raccoon/Weasel');
      }else if (newSelection === '10541') {
        setSelectedTitle('FWUpdater');
      }else if (newSelection === '10543') {
        setSelectedTitle('SSI');
      }else if (newSelection === '21118') {
        setSelectedTitle('Boomerang');
      }
    };

    const SuiteToggleButton = styled(ToggleButton)({
      flex: 1,
      boxShadow: 'none',
      textTransform: 'none',
      color: '#406599',
      '&:hover': {
        backgroundColor: '#c6e5fb',
      },
      "&.Mui-selected, &.Mui-selected:hover": {
        color: "#406599",
        backgroundColor: '#9cd1f8'
      }
    });


    const getTestrailAutomatedCases = async (selected) => {
      console.log(selected);
      try {
        var input_data = JSON.stringify({ suite_id: parseInt(selected) });
        const response = await axios.post("/peloton/v1/automation/testrail-automated-report", input_data, { withCredentials: true});
        if (response.data.message === "success"){
                    setCategories(response.data.categories);
                    setPercentage(response.data.percentage_list);
                    setTotalList(response.data.total_list);
                    setAutomatedList(response.data.automated_list);
                    setSummariesData(response.data.data);
        }
      } catch (error) {
                if (error.response.status !== null){
                    if (error.response.status === 401){
                        alert(error.response.data.message);
                        navigate("/");
                    }else{
                        console.log('error.response.status: ', error.response.status)
                        console.log('error.response.message: ', error.response.data.message)
                    }
                }else{
                    console.log(error);
                }
      }finally {
                setLoading(false);
      }
    };

    

    useEffect(() => {
      if (initialFetchRef.current) {
        initialFetchRef.current = false;
        getTestrailAutomatedCases(selected);
      } 
    }, [selected]);

    if (loading) {
        return <div>Loading...</div>;
    }


    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "45px", marginLeft: "40px"}}>
            <MainCard title={'System App Automated Cases'}>
            <Grid item xs={12} sx={{ minWidth: "1080px"}}>
            <ToggleButtonGroup
              value={selected}
              exclusive
              onChange={handleSelection}
              aria-label="select option"
              sx={{ display: "flex", width: "100%"}}
            >
              <SuiteToggleButton value="10539" aria-label="Affernet">
                Affernet
              </SuiteToggleButton>
              <SuiteToggleButton value="10541" aria-label="FWUpdater">
                FWUpdater
              </SuiteToggleButton>
              <SuiteToggleButton value="10538" aria-label="OTAService">
                OTAService
              </SuiteToggleButton>
              <SuiteToggleButton value="10540" aria-label="Raccoon/Weasel">
                Raccoon/Weasel
              </SuiteToggleButton>
              <SuiteToggleButton value="10543" aria-label="SSI">
                SSI
              </SuiteToggleButton>
              <SuiteToggleButton value="21118" aria-label="Boomerang">
                Boomerang
              </SuiteToggleButton>
            </ToggleButtonGroup>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "20px"}}>
                <GeneralNoPaginationTable rows={summariesData} columns={summaries_columns} title="Created and Updated Test Cases"/>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "20px"}}>
              <MixedChart isLoading={loading} categories={categories} percentage={percentage} totalList={totalList} automatedList={automatedList} selected={selected} selectedTitle={selectedTitle}/>
            </Grid>
            </MainCard>
        </Grid>
    );
};

export default TestRailSYSAutomatedInfoPage;
